import z from "zod";
import { userSchema } from "../user";
import { createZodDto } from "nestjs-zod/dto";
import { withdrawalSchema } from "./withdrawal";

export const createWithdrawalSchema = withdrawalSchema.pick({
  amount: true,
  userId: true,
  mean: true,
  phoneMomo: true,
  bankNumber: true,
});

export class CreateWithdrawalDto extends createZodDto(createWithdrawalSchema) {}
